import { render, staticRenderFns } from "./EmailSubmitForm.vue?vue&type=template&id=c321dda4&scoped=true&"
import script from "./EmailSubmitForm.vue?vue&type=script&lang=js&"
export * from "./EmailSubmitForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailSubmitForm.vue?vue&type=style&index=0&id=c321dda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c321dda4",
  null
  
)

export default component.exports